import { useLocalization } from "@fluent/react";
import { IconButton } from "@narmi/design_system";
import { useToastsContext } from "@lending/hooks/useToasts";
import styles from "./ToastsContainer.module.css";

const TOAST_ICON_CLASSNAMES = {
  negative: "narmi-icon-alert-circle",
  success: "narmi-icon-check-circle",
  info: "narmi-icon-info",
};

export default function ToastsContainer() {
  const { l10n } = useLocalization();
  const { toastsState, dismissToast } = useToastsContext();
  return (
    <div className={styles.toastContainer}>
      {toastsState.map((toast) => (
        <div key={toast.text + toast.type} className={`${styles.toast} ${styles[toast.type]}`}>
          <span
            className={`${TOAST_ICON_CLASSNAMES[toast.type]} ${styles[`icon-${toast.type}`]}`}
          />
          <p>{toast.text}</p>
          <IconButton
            label={l10n.getString("ui-dismiss", null, "Dismiss")}
            kind="plain"
            name="x"
            size="xl"
            onClick={() => {
              dismissToast(toast);
            }}
          />
        </div>
      ))}
    </div>
  );
}
